import { render, staticRenderFns } from "./chatButton.vue?vue&type=template&id=433b3e41&lang=pug&"
import script from "./chatButton.vue?vue&type=script&lang=ts&"
export * from "./chatButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports